import React, { useEffect, useMemo, useRef } from 'react';

function safeDestroyMagnific(jq, selector) {
  try {
    jq(selector).magnificPopup('destroy');
  } catch (_) {
    // ignore
  }
}

export default function FluidGallery({ images = [] }) {
  const rootRef = useRef(null);

  const normalized = useMemo(() => {
    const list = Array.isArray(images) ? images : [];
    return list
      .filter((x) => x && x.url)
      .map((x, idx) => ({
        id: x.id ?? idx,
        title: x.title || x.name || 'Photo',
        description: x.description || '',
        thumbUrl: x.thumbUrl || x.url,
        url: x.url
      }));
  }, [images]);

  useEffect(() => {
    const jq = window.jQuery || window.$;
    if (!jq || !jq.fn || !jq.fn.magnificPopup) return undefined;
    const selector = rootRef.current ? jq(rootRef.current).find('.gallery-one') : null;
    if (!selector || selector.length === 0) return undefined;

    safeDestroyMagnific(jq, selector);
    selector.magnificPopup({
      delegate: 'a',
      type: 'image',
      gallery: { enabled: true }
    });

    return () => safeDestroyMagnific(jq, selector);
  }, [normalized.length]);

  return (
    <div ref={rootRef} className="cd-hero">
      <ul className="cd-hero-slider">
        <li className="selected">
          <div className="cd-full-width">
            <div className="container-fluid js-tm-page-content" data-page-no="1" data-page-type="gallery">
              <div className="tm-img-gallery-container">
                <div className="tm-img-gallery gallery-one">
                  {normalized.map((img) => (
                    <div className="grid-item" key={img.id}>
                      <figure className="effect-sadie">
                        <img src={img.thumbUrl} alt={img.title} className="img-fluid tm-img" />
                        <figcaption>
                          <h2 className="tm-figure-title">
                            {img.title}
                          </h2>
                          {img.description ? <p className="tm-figure-description">{img.description}</p> : null}
                          <a href={img.url}>View more</a>
                        </figcaption>
                      </figure>
                    </div>
                  ))}

                  {normalized.length === 0 ? (
                    <div className="text-muted small">No photos available.</div>
                  ) : null}
                </div>
              </div>
            </div>
          </div>
        </li>
      </ul>
    </div>
  );
}

